module.exports = __webpack_public_path__ + "img/2.af9ee695.png";